import * as Yup from 'yup'

export const setupValidationSchema = () => (
  Yup.object().shape({
    // basic billing details
    contactName: Yup.string()
      .required('Name is required'),
    contactEmail: Yup.string()
      .email('Invalid email').required('Email is required'),
    contactPhone: Yup.string()
      .required('Phone is required'),
    companyVat: Yup.string()
      .required('Company VAT number is required.'),
    // address details
    city: Yup.string()
      .required('City is required'),
    suburb: Yup.string()
      .nullable(),
    country: Yup.string()
      .required('Country is required'),
    code: Yup.string()
      .required('Code is required'),
    line1: Yup.string()
      .required('Address is required'),
    line2: Yup.string()
      .nullable(),
    line3: Yup.string()
      .nullable(),
  })
)

export const propsToValues = (billable, address) => {
  return {
    // billable
    contactName: billable?.contact_name,
    contactEmail: billable?.contact_email,
    contactPhone: billable?.contact_phone,
    companyVat: billable?.company_vat,
    // address
    city: address?.city,
    suburb: address?.suburb,
    country: address?.country,
    code: address?.code,
    line1: address?.line_1,
    line2: address?.line_2,
    line3: address?.line_3,
  }
}